/** Paired central stairs retain side cheeks, with open risers and a clear rear landing bay. */
export function hasOpenRiserSides(bed: {kind?: string; customStyle?: string; stairStyle?: string}) {
  return (bed.kind === 'bridge' || (bed.kind === 'custom' && bed.customStyle === 'rosemary')) &&
    (!bed.stairStyle || bed.stairStyle === 'enclosed')
}
